"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtensionRoutes = exports.ExtensionContextProvider = exports.AsyncExtensionsMaster = exports.ASYNC_EXTENSION = exports.getExtension = exports.getExtensions = exports.loadPluginsWithDependencies = exports.extensionRegistration = exports.ChildOnlyOption = exports.getExtensionPage = exports.useExtensionPage = exports.getMasterComponents = exports.useExtensionContext = exports.sendUpdate = exports.extensionContextValue = exports.api = exports.componentExtensionTopic = exports.extensionTopic = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const configuration_resolvers_1 = require("./configuration-resolvers");
const utils_1 = require("./utils");
const auth_context_1 = require("./auth-context");
const extension_hooks_1 = require("./extension-hooks");
const feature_context_1 = require("./feature-context");
const extensionTopic = (name) => `extension:${name}`;
exports.extensionTopic = extensionTopic;
const componentExtensionTopic = (name) => `component_extension:${name}`;
exports.componentExtensionTopic = componentExtensionTopic;
const featureToggles = (typeof localStorage != 'undefined' ? JSON.parse((_a = localStorage.getItem('FEATURES')) !== null && _a !== void 0 ? _a : '{}') : {});
const extension = (name, ext) => {
    if (!extensionContextStore.extensions[name])
        extensionContextStore.extensions[name] = [];
    extensionContextStore.extensions[name].push(ext);
    sendUpdate((0, exports.extensionTopic)(name));
};
function masterOrderedComponent(component, requestedOrder) {
    // prevent double registering the same component
    if (extensionContextStore.master.some(a => a.comp == component))
        return;
    extensionContextStore.master.push({ order: requestedOrder, comp: component });
    // this can't happen after initPlugin
}
function masterComponent(component, prepend) {
    masterOrderedComponent(component, prepend ? 0 : 100000);
}
exports.api = {
    route: (slug, route) => {
        extensionContextStore.routeMatches.push({
            slug,
            slugMatch: null,
            route
        });
    },
    extension,
    asyncHook: (hook) => {
        extension(exports.ASYNC_EXTENSION, (reg) => {
            if (reg)
                return;
            hook();
        });
    },
    componentExtension: (name, component, requireFlags) => {
        // define a regular extension with the flags
        extension(`component-${name}`, {
            component,
            requireFlags
        });
        // if (!extensionContextStore.componentExtensions[name]) extensionContextStore.componentExtensions[name] = [];
        // extensionContextStore.componentExtensions[name].push(component);
        sendUpdate((0, exports.componentExtensionTopic)(name));
    },
    masterOrderedComponent,
    masterComponent,
    feature: (name, enableByDefault) => {
        var _a;
        const enabled = (_a = featureToggles[name]) !== null && _a !== void 0 ? _a : enableByDefault;
        extensionContextStore.features.push({ name, enableByDefault, enabled });
        return enabled;
    },
    requestFeature: (name, enable) => {
        featureToggles[name] = enable;
        window.localStorage['FEATURES'] = JSON.stringify(featureToggles);
    },
    getAccessToken: () => auth_context_1.CurrentIdentity && auth_context_1.CurrentIdentity.accessToken
};
exports.extensionContextValue = {
    // getComponentExtension,
    // getComponentExtensions,
    getExtensions,
    subscribeUpdates,
    feature: exports.api.feature,
    requestFeature: exports.api.requestFeature
};
function sendUpdate(topic, detail) {
    const event = new CustomEvent(`pubsub:${topic}`, {
        detail
    });
    document.dispatchEvent(event);
    // PubSub.publish(topic, true);
}
exports.sendUpdate = sendUpdate;
const ExtensionContext = (0, react_1.createContext)(exports.extensionContextValue);
function useExtensionContext() {
    const context = (0, react_1.useContext)(ExtensionContext);
    if (!context) {
        throw new Error('Extension Context is not available.');
    }
    return context;
}
exports.useExtensionContext = useExtensionContext;
function NotFoundComponent() {
    const NotFoundPage = (0, extension_hooks_1.useComponentExtension)('404-page', true);
    if (NotFoundPage)
        return React.createElement(NotFoundPage, null);
    return React.createElement("h1", null, "404");
}
const DefaultMaster = ({ children }) => React.createElement(React.Fragment, null, children);
/** Obtains the master component registrations.
 *
 * This is deliberately not titled using a use prefix as it isn't using any hooks internally */
function getMasterComponents() {
    const orderedComponents = extensionContextStore.master.sort((a, b) => a.order - b.order).map(a => a.comp);
    // obtains the master page component or defaults to React.Fragment as a noop
    return orderedComponents !== null && orderedComponents !== void 0 ? orderedComponents : [DefaultMaster];
}
exports.getMasterComponents = getMasterComponents;
function useExtensionPage(page) {
    const flags = (0, feature_context_1.useAccessFlags)();
    return getExtensionPage(page, flags);
}
exports.useExtensionPage = useExtensionPage;
function getExtensionPage(page, flags) {
    if (!page)
        page = '/';
    for (const r of extensionContextStore.routeMatches) {
        if (typeof page === 'string' &&
            r.slug == page &&
            (!r.route.requireFlags || r.route.requireFlags.every(s => (flags === null || flags === void 0 ? void 0 : flags.has(s)) == true))) {
            return r.route;
        }
    }
    const defaultPage = extensionContextStore.routeMatches.filter(a => a.slug == '*')[0];
    if (defaultPage)
        return defaultPage.route;
    return { title: 'Not Found', PageComponent: NotFoundComponent, anonymous: false };
}
exports.getExtensionPage = getExtensionPage;
var ChildOnlyOption;
(function (ChildOnlyOption) {
    ChildOnlyOption["RedirectToRoot"] = "Root";
    ChildOnlyOption["NoClick"] = "NoClick";
})(ChildOnlyOption = exports.ChildOnlyOption || (exports.ChildOnlyOption = {}));
const extensionContextStore = {
    master: [],
    routeMatches: [],
    // componentExtensions: {},
    extensions: {},
    features: []
};
const extensionRegistration = (config) => (Object.assign({ config }, exports.api));
exports.extensionRegistration = extensionRegistration;
function loadPluginsWithDependencies(configs, loadPluginManifestEntries) {
    return __awaiter(this, void 0, void 0, function* () {
        // each round of script loading needs to fetch the manifest and then pass that back to the caller
        function processPlugin(plugin) {
            return __awaiter(this, void 0, void 0, function* () {
                const { scripts } = (0, configuration_resolvers_1.fetchManifest)(plugin);
                loadPluginManifestEntries(scripts);
            });
        }
        const roundLoad = configs.map(processPlugin);
        yield Promise.all(roundLoad);
    });
}
exports.loadPluginsWithDependencies = loadPluginsWithDependencies;
// export function getComponentExtensions(name: string) {
// 	return extensionContextStore.componentExtensions[name] || [];
// }
/** For non-react use you may get "data" extensions from the store. Note if the extension requires react, you should call this via the
 * hook version otherwise things might not work as expected. */
function getExtensions(name) {
    var _a;
    return (_a = extensionContextStore.extensions[name]) !== null && _a !== void 0 ? _a : [];
}
exports.getExtensions = getExtensions;
function getExtension(name) {
    return getExtensions(name)[0];
}
exports.getExtension = getExtension;
// function getComponentExtension(name: string) {
// 	return extensionContextStore.componentExtensions[name]?.[0] || null;
// }
function subscribeUpdates(topic, receiver) {
    document.addEventListener(`pubsub:${topic}`, receiver);
    // const res = PubSub.subscribe(topic, receiver);
    return () => document.removeEventListener(`pubsub:${topic}`, receiver);
}
exports.ASYNC_EXTENSION = 'react-extension-async';
const AsyncExtensionsMaster = function AsyncExtensions({ children }) {
    // we need to observe the rules around hooks.
    // this is so the react-extension-async can call react hooks safely
    // we need to not change the number of hooks being called
    // and this method MIGHT be called many times (as identity is above us and we might have a re-render due to getting a new token)
    // the solutions to these are to obtain the hook-extensions on first render and store that in a ref. this should maintain a static list from that point
    // I am spreading the array in the useRef call to ensure the array itself can't be modified accidentally or by subsequent registrations
    // to control subsequent render registrations, the hasRendered ref keeps track of this and is passed into the registration function
    const initialHooks = React.useRef([...getExtensions(exports.ASYNC_EXTENSION)]);
    const hasRendered = React.useRef(false);
    // it is unlikely current will be flipped early but I am in extra paranoia mode
    const thisHasRendered = hasRendered.current;
    hasRendered.current = true;
    for (const h of initialHooks.current) {
        h(thisHasRendered);
    }
    return React.createElement(React.Fragment, null, children);
};
exports.AsyncExtensionsMaster = AsyncExtensionsMaster;
const ExtensionContextProvider = ({ children, isServer, host }) => {
    return React.createElement(ExtensionContext.Provider, { value: exports.extensionContextValue }, children);
};
exports.ExtensionContextProvider = ExtensionContextProvider;
if (!!utils_1.win['__DEV_EXTENSION_STORE']) {
    console.warn('There appears to be an existing store mounted on the page; this is unsupported.');
}
else {
    // debugging
    utils_1.win['__DEV_EXTENSION_STORE'] = extensionContextStore;
    utils_1.win['__DEV_EXTENSION_API'] = exports.api;
}
const getExtensionRoutes = () => {
    return extensionContextStore.routeMatches.filter(route => { var _a; return ((_a = route.route) === null || _a === void 0 ? void 0 : _a.parentRoute) && route; });
};
exports.getExtensionRoutes = getExtensionRoutes;
